<script lang="ts">
	import type { MenuItem } from "../../../../core/schema/MenuItem.js";
	import Icon from "../Icon.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { appName } from "../../../../core/schema/names/appName.js";
	import close from "../../../../core/assets/icons/close.svg?raw";
	import Menu from "./Menu.svelte";
	import translations from "./MobileMenu.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { getTenant } from "../../getTenant.js";
	import { homepagePathMap } from "../../../../core/schema/paths/homepagePathMap.js";

	export let pageSlug: string;
	export let isOpen = false;
	export let menu: MenuItem[];
	export let logo: string;

	function onClose(): void {
		isOpen = false;
	}

	function onClick({ detail }: CustomEvent<MenuItem>): void {
		if (detail.id === "kontakt") {
			isOpen = false;
		}
	}
	const translate = getTranslate(translations);
	const tenant = getTenant();
</script>

<nav
	class="block {isOpen &&
		'bg-ltwhiteout fixed left-0 top-0 z-50 m-0 flex h-full w-[16.0625rem] flex-col py-3 shadow-[0.25rem_0_1rem_rgba(0,0,0,0.12)]'}"
>
	<div class="flex items-center justify-between px-6 pt-4">
		<a href="/{homepagePathMap[tenant.locale]}" class="w-28">
			<StaticPicture alt="Logo {appName}" image={logo} class="w-28 xl:hidden" loading="eager" width={142} height={64} />
		</a>
		<button on:click={onClose}>
			<span
				class="text-2xs/5 hover:text-ltprimary-300 flex items-center gap-1 font-semibold uppercase transition-colors duration-300 ease-in-out"
			>
				{translate("close")}
				<Icon icon={close} class="size-2.5" />
			</span>
		</button>
	</div>

	<Menu {pageSlug} {menu} on:click={onClick} />
</nav>
